import { observer } from 'mobx-react-lite'
import { StepsCommonLayout } from 'pages/settings/ui/StepsCommonLayout/StepsCommonLayout'
import {
  useComplianceLayerContext,
  CompliancePageProvider,
  useCompliancePageContext,
} from 'pages/settings/pages/compliance/context'

export const CallingCnamEditNumbersContent = observer(() => {
  const {
    callingPageStore: {
      editCnamNumbersStore: { editingCnam, closeSetting },
    },
  } = useCompliancePageContext()

  return (
    <StepsCommonLayout
      progressTitle={editingCnam?.name || ''}
      totalSteps={1}
      title={'Edit CNAM Caller ID'}
      settingsStep={1}
      closeSetting={closeSetting}
    />
  )
})

export const CallingCnamEditNumbersLayout = () => {
  const complianceLayerStore = useComplianceLayerContext()

  return (
    <CompliancePageProvider complianceLayerStore={complianceLayerStore}>
      <CallingCnamEditNumbersContent />
    </CompliancePageProvider>
  )
}
